import { render, staticRenderFns } from "./apiList.vue?vue&type=template&id=1d5b37e5"
import script from "./apiList.vue?vue&type=script&lang=js"
export * from "./apiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports